import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import './ShowcaseView.css';

const ShowcaseView = () => {
  const navigate = useNavigate();
  const [centros, setCentros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/api/centros')
      .then(res => {
        if (res.data.success) setCentros(res.data.centros || []);
      })
      .catch(() => setCentros([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="showcase-loading">Cargando...</div>;
  }

  return (
    <div className="showcase-view">
      <header className="showcase-header">
        <h1>Multicentro Comercial Virtual</h1>
        <div className="showcase-links">
          <a href="/showcase" className="active">Directorio</a>
          <a href="/">Globe</a>
        </div>
      </header>

      <div className="showcase-grid">
        {centros.map((c) => (
          <div key={c.id} className="showcase-card">
            <div className="showcase-card-image">
              {c.imagen_portada ? (
                <img src={c.imagen_portada} alt="" />
              ) : (
                <div className="showcase-card-placeholder">🏬</div>
              )}
            </div>
            <div className="showcase-card-body">
              <h3>{c.nombre}</h3>
              {c.ciudad && <p className="city">{c.ciudad}</p>}
              {c.descripcion && <p>{c.descripcion}</p>}
              <button className="btn-play" onClick={() => navigate(`/centro/${c.id}`)}>
                ▶ Entrar al recorrido
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShowcaseView;
